import api from '../api'

export const postMachine = (params) => api.post('/farms/machines', params)

export const putMachine = ({ id, ...params }) => api.put(`/farms/machines/${ id }`, params)

export const deleteMachine = ({ id }) => api.delete(`/farms/machines/${ id }`)
